.page {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	white-space: normal;
}

.headerWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;

	& .title {
		color: #000000;
		font-weight: 600;
		font-size: 1.125rem;
		line-height: 1.4;
	}
}

.sectionWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.sectionHeader:global(.MuiTypography-root) {
	font-size: 0.9375rem;
	font-weight: 600;
	border-bottom: 1px solid #e0e0e0;
	color: #000000;
	line-height: 1.5;
}

.sectionDescription:global(.MuiTypography-root) {
	font-size: 0.9375rem;
	color: #757575;
	font-weight: 400;
	text-align: left;
}

.radioCardWrapper {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	align-items: stretch;
	gap: 1rem;
}

.profileSection {
	display: flex;
	flex-direction: column;
	padding: 0.5rem !important;
}

.profileSectionContentList {
	display: flex;
	padding: 0.25rem;
	box-sizing: border-box;
}

.notesSectionContentTextBox {
	display: flex;
	flex-direction: column;
	align-items: start;
	justify-content: start;
	width: 100%;
	max-width: 100%;
	height: 220px;
	font-size: 15px;
	color: #696969;
	resize: vertical;

	& :global(.MuiOutlinedInput-root) {
		height: 100%;
		width: 100%;
		margin: 0;
		font-size: 0.9375rem;
		text-align: left;
	}

	& :global(.MuiOutlinedInput-input) {
		line-height: 1.5;
		text-align: left;
		height: 100%;
		width: 100%;
		font-size: 0.9375rem;
	}
}

.proctorButtonContainer {
	flex: 1;
	padding: 1.25rem;
}

.proctorButton:global(.MuiButton-root) {
	align-items: flex-start;
	justify-content: space-between;
	display: flex;
	flex-direction: row;
	max-height: unset;
	height: 100%;

	& .proctorInfoCol {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
	}

	& .title {
		color: #000000;
		font-weight: 600;
		font-size: 1rem;
		line-height: 1.4;
	}

	& .description {
		color: #5d5d5d;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
		text-align: left;
	}
}

.topRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	width: 100%;

	& .saveButton {
		height: 35px;
	}
}

@media (max-width: 768px) {
	.radioCardWrapper {
		flex-direction: column;
	}

	.profileSectionContentList {
		padding: 0;
	}

	.notesSectionWrapper {
		flex-direction: column-reverse;
	}

	.topRow {
		justify-content: flex-start;
	}
}
